import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BbitArray } from '@bbitgmbh/bbit.utils';
import { BbitWebsiteService, LuxonPipe } from '@bbitgmbh/website.sdk';
import { DateTime } from 'luxon';
import QRCode from 'qrcode';
import { IAccess, PlaceBookingService } from '../booking/booking.service';

@Component({
  selector: 'app-access',
  imports: [LuxonPipe],
  templateUrl: './access.component.html',
  styleUrl: './access.component.scss',
})
export class AccessComponent {
  public website = inject(BbitWebsiteService);
  public access = signal<IAccess | undefined>(undefined);
  public accessQRCode = signal('');
  public accessPin = signal('');
  public accessTimes = signal<{ from: DateTime; until: DateTime }[]>([]);
  private _booking = inject(PlaceBookingService);

  constructor() {
    this.website
      .observeAuthenticated()
      .pipe(takeUntilDestroyed())
      .subscribe((auth) => {
        if (!auth) {
          this.access.set(undefined);
          return;
        }
        this._loadAccess();
      });
  }

  private async _loadAccess(): Promise<void> {
    const data = await this._booking.getAccess();
    this.access.set(data);

    if (data.credentials?.barcodeNumber) {
      QRCode.toDataURL(data.credentials.barcodeNumber, (err, url) => {
        if (err) {
          return;
        }
        this.accessQRCode.set(url);
      });
    }
    if (data.credentials?.pin) {
      this.accessPin.set(data.credentials.pin);
    }
    if (data.nextBookings?.length > 0) {
      const times = data.nextBookings.map((booking) => {
        return {
          from: DateTime.fromISO(booking.from),
          until: DateTime.fromISO(booking.until),
        };
      });
      const uniqueTimes = times.filter(
        (time, index, self) => self.findIndex((t) => t.until.toMillis() === time.until.toMillis()) === index,
      );
      this.accessTimes.set(BbitArray.sortBy(uniqueTimes, (o) => o.from.toMillis()));
    }
  }
}
